<template>
  <div style="header_page">
    <div class="my_header">
      <div class="">
        <!-- <div class="box pcmain">
          <div class="welcome_bar"> 欢迎来到{{site.name}}! </div>
          <div class="welcome_bar"></div>
          <div class="tel_bar">
            <div class="tel_bar">
              <span class="title">服务热线：</span>
              <em>963111</em>
              <span class="tel">{{site.mobile}}</span>
            </div>
          </div>
        </div> -->

        <div class="pc-item pc_header">
          <div class="pcmain">
            <div class="logo_navigation_bar">
              <!-- <div class="logo_bar">
                <router-link to="/"   >
                    <img   v-lazy="site.logo_path"  :data-src="site.logo_path" alt="回到首页" title="回到首页"   />

                </router-link>
            </div> -->

              <div class="pc_navigation">
                <ul>
                  <li v-for="(item, index) in navigation_lists" :key="index">
                    <div
                      class="nav"
                      @mouseover="mouseOver"
                      @mouseleave="mouseLeave"
                    >
                      <a :href="item.url" :target="item.target">{{
                        item.name
                      }}</a>
                    </div>
                    <!--
                               @mouseover="set_pc_sub_navigation_hover(index)"
                               @mouseleave="un_pc_sub_navigation_hover(index)"
                               @mouseleave="un_pc_sub_navigation_hover(index)"
{{sub_item.name}}
                               -->
                    <ol v-if="item.sub_lists.length > 0">
                      <li
                        v-for="(sub_item, sub_index) in item.sub_lists"
                        :key="sub_index"
                      >
                        <!-- <a :href="sub_item.url" :target="sub_item.target" ></a> -->
                      </li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 子导航  pc_sub_navigation_classObject -->
          <div
            ref="acp"
            class="pc_sub_navigation"
            v-bind:class="pc_sub_navigation_classObject"
            @mouseover="mouseOver"
            @mouseleave="mouseLeave"
          >
            <div class="pcmain">
              <div class="row">
                <!-- <div class="logo_bar">
                <router-link to="/"   >
                     <img class=""     v-lazy="site.logo_path"  :data-src="site.logo_path" alt="回到首页" title="回到首页"    />
                </router-link>
            </div> -->

                <ul>
                  <li
                    :class="item.className"
                    v-for="(item, index) in navigation_lists"
                    :key="index"
                    v-bind:class="item.sub_lists.length == 0 ? 'ssssss' : ''"
                  >
                    <div class="nav">
                      <a :href="item.url" :target="item.target">{{
                        item.name
                      }}</a>
                    </div>
                    <ol v-if="item.sub_lists.length > 0">
                      <li
                        v-for="(sub_item, sub_index) in item.sub_lists"
                        :key="sub_index"
                      >
                        <a :href="sub_item.url" :target="sub_item.target">{{
                          sub_item.name
                        }}</a>
                      </li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 子导航 /-->
        </div>

        <!--

手机端

-->
        <div class="mobile-item mobile_header">
          <ul>
            <li v-for="(item, index) in navigation_lists" :key="index">
              <div class="nav">
                <a :href="item.url" :target="item.target">{{ item.name }}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="clearfix"></div>
      <!--

<div class="mobile_navigation" v-if="show_mobile_navigation"  @click="show_mobile_navigation = false">

:class="mobile_navigation_style"

<el-dialog   :visible.sync="show_mobile_navigation"  :fullscreen="true"  	 >
-->

      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import bus from "@/components/common/bus";

import Storage from "@/components/libs/storage";
import Site from "@/components/model/site/site";

import Navigation from "@/components/model/navigation/navigation";

export default {
  data() {
    return {
      SITE_NAME: SITE_NAME + " - 后台管理系统 ",
      collapse: false,
      fullscreen: false,
      name: "外星人来了",
      message: 2,

      show_mobile_navigation: false,

      mobile_navigation_style: "mobile_navigation",
      // mobile_navigation_style :  'mobile_navigation mobile_navigation_open',
      // <div class="mobile_menu mobile_menu_open"
      mobile_menu_style: "mobile_menu",

      pc_sub_navigation_classObject: "",

      // @mouseover="set_pc_sub_navigation_hover(index)"
      // @mouseleave="un_pc_sub_navigation_hover(index)"
      // sub_navigation_hover:[
      //   {'classname':'sub_navigation_hover'},
      // ],
      pc_sub_navigation_hover_style_0: "sub_navigation_hover",
      pc_sub_navigation_hover_style_1: "sub_navigation_hover",
      pc_sub_navigation_hover_style_2: "sub_navigation_hover",
      pc_sub_navigation_hover_style_3: "sub_navigation_hover",
      pc_sub_navigation_hover_style_4: "sub_navigation_hover",
      pc_sub_navigation_hover_style_5: "sub_navigation_hover",
      pc_sub_navigation_hover_style_6: "sub_navigation_hover",
      pc_sub_navigation_hover_style_7: "sub_navigation_hover",
      pc_sub_navigation_hover_style_8: "sub_navigation_hover",
      pc_sub_navigation_hover_style_9: "sub_navigation_hover",
      pc_sub_navigation_hover_style_10: "sub_navigation_hover",
    };
  },
  computed: {
    username() {
      const that = this;
      return "";
    },
  },
  props: ["navigation_lists", "site"],
  created() {
    const that = this;
    // that.get_site()
    // that.get_navigation_main_lists()
  },
  methods: {
    // @mouseover="set_pc_sub_navigation_hover(index)"
    set_pc_sub_navigation_hover(index) {
      const that = this;
      switch (index) {
        case 0:
          that.pc_sub_navigation_hover_style_0 = "sub_navigation_hover";
          break;
        case 1:
          that.pc_sub_navigation_hover_style_1 = "sub_navigation_hover";
          break;
        case 2:
          that.pc_sub_navigation_hover_style_2 = "sub_navigation_hover";
          break;
        case 3:
          that.pc_sub_navigation_hover_style_3 = "sub_navigation_hover";
          break;
        case 4:
          that.pc_sub_navigation_hover_style_4 = "sub_navigation_hover";
          break;
        case 5:
          that.pc_sub_navigation_hover_style_5 = "sub_navigation_hover";
          break;
        case 6:
          that.pc_sub_navigation_hover_style_6 = "sub_navigation_hover";
          break;
        case 7:
          that.pc_sub_navigation_hover_style_7 = "sub_navigation_hover";
          break;
        case 8:
          that.pc_sub_navigation_hover_style_8 = "sub_navigation_hover";
          break;
        case 9:
          that.pc_sub_navigation_hover_style_9 = "sub_navigation_hover";
          break;
        case 10:
          that.pc_sub_navigation_hover_style_10 = "sub_navigation_hover";
          break;
      }
      console.info("set_pc_sub_navigation_hover", index);
    },

    // @mouseleave="un_pc_sub_navigation_hover(index)"
    un_pc_sub_navigation_hover(index) {
      const that = this;
      switch (index) {
        case 0:
          that.pc_sub_navigation_hover_style_0 = "";
          break;
        case 1:
          that.pc_sub_navigation_hover_style_1 = "";
          break;
        case 2:
          that.pc_sub_navigation_hover_style_2 = "";
          break;
        case 3:
          that.pc_sub_navigation_hover_style_3 = "";
          break;
        case 4:
          that.pc_sub_navigation_hover_style_4 = "";
          break;
        case 5:
          that.pc_sub_navigation_hover_style_5 = "";
          break;
        case 6:
          that.pc_sub_navigation_hover_style_6 = "";
          break;
        case 7:
          that.pc_sub_navigation_hover_style_7 = "";
          break;
        case 8:
          that.pc_sub_navigation_hover_style_8 = "";
          break;
        case 9:
          that.pc_sub_navigation_hover_style_9 = "";
          break;
        case 10:
          that.pc_sub_navigation_hover_style_10 = "";
          break;
      }
      console.info("un_pc_sub_navigation_hover", index);
    },

    // 移入
    mouseOver(e) {
      console.log(e);
      // 操作dom 获取p标签改变其样式
      const acps = this.$refs.acp;
      //  acps.style.color = "red"
      //acps.class='pc_sub_navigation_Over'
      this.pc_sub_navigation_classObject = "pc_sub_navigation_Over"; //移入
    },
    // 移出
    mouseLeave() {
      const acps = this.$refs.acp;
      // acps.class='pc_sub_navigation'
      this.pc_sub_navigation_classObject = "";
    },

    //sessionStorage - 针对一个 session 的数据存储
    get_site() {
      const that = this;
      if (Storage.s_getItem("site") && Storage.s_getItem("site") !== "") {
        let _site = Storage.s_getItem("site");
        that.site.name = _site.name;
        that.site.tel = _site.mobile;
        if (_site.logo) {
          that.site.logo = _site.logo;
        }
        if (_site.logo_path) {
          that.site.logo_path = _site.logo_path;
        }

        console.log("Site ok  pcHeader.vue");
      } else {
        console.log("Site err112  pcHeader.vue");
        Site.info({})
          .then((res) => {
            if (res.status == 1) {
              Storage.s_setItem("site", res.data.result);
              // that.get_site();
              let _site = res.data.result;
              that.site.name = _site.name;
              that.site.tel = _site.mobile;
              if (_site.logo) {
                that.site.logo = _site.logo;
              }
              if (_site.logo_path) {
                that.site.logo_path = _site.logo_path;
              }
            }
          })
          .catch((res) => {
            console.info("Site.info", res);
          });
      }
    },

    //   导航 main_lists

    //                get_navigation_main_lists(){
    //                    const that = this;

    //                    if(Storage.s_getItem('navigation_lists_header') && Storage.s_getItem('navigation_lists_header') !== '' ){
    //                             that.navigation_lists = Storage.s_getItem('navigation_lists_header') ;

    // that.navigation_lists.sort(function(a, b){
    //   ///return x.sort – y.sort;
    // //  return a['sort'] > b['sort'] ;
    //   return b['sort'] - a['sort'] ;
    // });

    //                     }else{
    //                             Navigation.main_lists({}).then(res => {
    //                                     if( res.status == 1  ){
    //                                         that.navigation_lists.length = 0;
    //                                         let list = [];
    //                                         let l ;
    // res.data.result.sort(function(a, b){
    //   ///return x.sort – y.sort;
    //   //return a['sort'] > b['sort'] ;
    //   return b['sort'] - a['sort'] ;
    // });

    //                                         res.data.result.forEach(( item,  index) => {
    //                                             if(item.parent_id === 0 ){
    //                                                    l = {
    //                                                           //  "url" : item.href,
    //                                                             "url" : item.url,
    //                                                              "sort" : item.sort,
    //                                                             "target":'_self',
    //                                                             'name': item.name,
    //                                                             'sub_lists':  [],
    //                                                     }
    //                                                     res.data.result.forEach(( sub_item,  sub_index) => {
    //                                                             if(item.id ===  sub_item.parent_id  ){
    //                                                                 l.sub_lists.push( {
    //                                                                   //  "url" : sub_item.href,
    //                                                                       "url" : sub_item.url,
    //                                                                        "sort" : sub_item.sort,
    //                                                                     "target":'_self',
    //                                                                     'name': sub_item.name,
    //                                                                 },)
    //                                                             }
    //                                                     });
    //                                                    list.push(l);
    //                                             }
    //                                         });
    //                                         that.navigation_lists = list  ;
    //                                         Storage.s_setItem('navigation_lists_header',list) ;
    //                                     }else{

    //                                     }
    //                             }).catch(res => {
    //                                 console.info('导航',res)
    //                             });
    //                     }
    //                },

    open_navigation_lists() {
      const that = this;
      that.show_mobile_navigation = !that.show_mobile_navigation;
      if (that.show_mobile_navigation === false) {
        console.info("-> false", that.show_mobile_navigation);
        that.mobile_navigation_style = "mobile_navigation";
        // that.mobile_menu_style =  'mobile_menu'
      } else {
        console.info("---> true", that.show_mobile_navigation);
        that.mobile_navigation_style =
          "mobile_navigation mobile_navigation_open";
        // that.mobile_menu_style =  'mobile_menu mobile_menu_open'
      }

      // console.info(that.show_mobile_navigation)
    },
  },
  mounted() {
    // if(document.body.clientWidth < 1500){
    //  //   this.collapseChage();
    // }
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/tmp/pcHeader.vue